module.exports = __WEBPACK_EXTERNAL_MODULE__js_joda_core__;